import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
import { FlashMessageGenerateTokenRequest } from '../api/flashmessagegeneratetoken/flashmessagegeneratetokenrequest';
import { FlashMessageGenerateTokenResponse, FlashMessageGenerateTokenResponseDtoImpl } from '../api/flashmessagegeneratetoken/flashmessagegeneratetokenresponse';
import { FlashMessageGenerateTokenBuilder } from '../dto/flashmessagegenereratetoken/flashmessagegeneratetokenbuilder';

export class FlashMessageGenerateTokenAPIProcessorImpl extends APIProcessorImpl<FlashMessageGenerateTokenRequest, FlashMessageGenerateTokenResponse>
{
    // execute(request: FlashMessageGenerateTokenRequest): void {
    //     let response = new FlashMessageGenerateTokenResponseDtoImpl(APIFeatures.GENERATE_FLASH_TOKEN, "Get FlashMessageGenerateToken Success");
    //     let flashmessagedto = new FlashMessageGenerateTokenDtoImpl();
    //     flashmessagedto.setAccessToken("jhgfdcvbnkuydfghj");
    //     response.setFlashMessageGenerateTokenResponseDto(flashmessagedto);
    //     this.getAPISuccess(response);
    // }
    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                if(+responseMapper.getStatusCodeOutside() === 0)
                {
                    let response = new FlashMessageGenerateTokenResponseDtoImpl(APIFeatures.GENERATE_FLASH_TOKEN, "Get FlashMessageGenerateToken Success");
                    response.setFlashMessageGenerateTokenResponseDto(new FlashMessageGenerateTokenBuilder(responseMapper.getResponseMap()).buildAll());
                    this.getAPISuccess(response);
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.NO_CONTENT)
                {
                    this.getAPISuccess(new FlashMessageGenerateTokenResponseDtoImpl(APIFeatures.GENERATE_FLASH_TOKEN, this.getContext().getResources().getString(Strings.no_data_list_available)));
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.INTERNAL_SERVER_ERROR)
                {
                    this.getAPIFailure(new FlashMessageGenerateTokenResponseDtoImpl(APIFeatures.GENERATE_FLASH_TOKEN, this.getContext().getResources().getString(Strings.internal_server_error)));
                }
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new FlashMessageGenerateTokenResponseDtoImpl(APIFeatures.GENERATE_FLASH_TOKEN, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new FlashMessageGenerateTokenResponseDtoImpl(APIFeatures.GENERATE_FLASH_TOKEN, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new FlashMessageGenerateTokenResponseDtoImpl(APIFeatures.GENERATE_FLASH_TOKEN, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
      
            this.getAPIFailure(new FlashMessageGenerateTokenResponseDtoImpl(APIFeatures.GENERATE_FLASH_TOKEN, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/generateflashtokenapiprocessor.tsx